import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { tokens } from "@cobee/cobee-ui";

export const useStyles = makeStyles(() =>
  createStyles({
    alert: {
      display: "flex",
      padding: "16px",
      backgroundColor: tokens.palette.info.light,
      borderRadius: "12px",
      "& .MuiAlert-message": {
        width: "100%",
      },
    },
    alertTitle: {
      color: tokens.palette.grey[900],
      ...tokens.typography["Body-L-500"],
      fontSize: tokens.typography["Body-L-500"].fontSize,
      fontWeight: 500,
      lineHeight: tokens.typography["Body-L-500"].lineHeight,
      fontFamily: "Poppins",
      marginTop: 0,
      marginBottom: "4px",
      textTransform: "none",
    },
    closeBtn: {
      marginBottom: "20px",
    },
    text: {
      color: tokens.palette.grey[900],
      fontSize: tokens.typography["Body-M-400"].fontSize,
      fontWeight: 400,
      lineHeight: tokens.typography["Body-M-400"].lineHeight,
      fontFamily: "Poppins",
    },
    innerContainer: {
      display: "flex",
      justifyContent: "space-between",
      fontFamily: "Poppins",
    },
    actionsContainer: {
      display: "flex",
      flexBasis: "26%",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-end",
      marginLeft: "24px",
    },
    actionButtonsContainer: {
      display: "flex",
      flexDirection: "row",
    },
    link: {
      position: "relative",
      fontSize: tokens.typography["Body-L-500"].fontSize,
      fontWeight: 500,
      lineHeight: tokens.typography["Body-L-500"].lineHeight,
      fontFamily: "Poppins",
    },
  })
);
